module.exports = __webpack_public_path__ + "img/youtuipiao.aaa8e4d7.svg";